import 'mdn-polyfills/Element.prototype.closest';
import StepForm from './StepForm';

document.addEventListener('DOMContentLoaded', () => {
  const $form = document.querySelector('.js-stepform');

  if ($form) {
    const $progressTrack = document.querySelector('.js-tunnel-progress-track');
    const $errors = $form.querySelectorAll('.c-form__field.has-error');
    let startIndex = 0;

    if ($errors.length) {
      startIndex = Array.from($form.querySelectorAll('.js-stepform-section')).indexOf($errors[0].closest('.js-stepform-section'));
    }

    const form = new StepForm($form, {
      stepsSectionSelector: '.js-stepform-section',
      navNextSelector: '.js-stepform-next',
      startIndex,
      callbacks: {
        onSectionDisplay: (instance, index) => {
          if ($progressTrack) {
            $progressTrack.style.width = `${((index + 1) / (instance.$sections.length + 1)) * 100}%`;
          }
        },
      },
    });

    form.mount();
  }
});
